import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { setTemplateFiles, clearTemplateFiles } from '@Redux/whatsappTemplateFile/whatsappTemplateFileAction';
import WhatsappTemplateFileService from '@Helpers/URLHelpers/WhatsappTemplateFileService';
import ErrorHandler from '@Root/ErrorHandler';

export const useReduxTemplateFiles = () => {

    const dispatch = useDispatch();
    const whatsappTemplateFileService = new WhatsappTemplateFileService();
    const errorHandler = new ErrorHandler();

    const templateFiles = useSelector((state) => state.templateFiles.templateFiles, shallowEqual);

    const fetchTemplateFileList = useCallback(async (leadsId) => {
        try {
            dispatch(clearTemplateFiles());
            let response = await whatsappTemplateFileService.getTemplateFileListByLeadsId(leadsId);
            if(response.status >= 400) return;
            response = JSON.parse(response.body);
            let templateFileObj = {};
            for(let i = 0; i < response.length; i++) {
                let currentObj = response[i];
                templateFileObj[currentObj.templateName] = currentObj;
            }
            dispatch(setTemplateFiles(templateFileObj));
        } catch (err) {
            errorHandler.handleError(err);
        }
    }, [dispatch]);

    const addNewFileForTemplate = useCallback(async (bodyStr) => {
        try {
            let response = await whatsappTemplateFileService.addNewFileForTemplate(bodyStr);
            if(response.status >= 400) return;
            response = JSON.parse(response.body);
            const updatedTemplateFiles = {
                ...templateFiles,
                [response.templateName]: response
            };
            dispatch(setTemplateFiles(updatedTemplateFiles));
            return response;
        } catch (err) {
            errorHandler.handleError(err);
            return null;
        }
    }, [dispatch]);

    const clearWhatsappTemplateFiles = useCallback(() => {
        dispatch(clearTemplateFiles());
    }, [dispatch]);

    return {
        templateFiles,
        fetchTemplateFileList,
        addNewFileForTemplate,
        clearWhatsappTemplateFiles: clearWhatsappTemplateFiles
    };
};
